<div class="card p-2">
    <div class="d-flex gap-4 mb-2">
        <span>{{ member.firstname }} {{ member.lastname }}</span>
        <span>{{ member.email }}</span>
        <span>{{ member.companyPosition }}</span>
    </div>
</div>
